import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type CircleOnDemandFacilitatorFragment = (
  { __typename?: 'CircleFacilitatorNode' }
  & Pick<Types.CircleFacilitatorNode, 'id' | 'photo' | 'name' | 'credential' | 'country' | 'countryCode'>
);

export type CircleOnDemandFragment = (
  { __typename?: 'CircleOnDemandNode' }
  & Pick<Types.CircleOnDemandNode, 'id' | 'uuid' | 'slug' | 'name' | 'description' | 'languageCode'>
  & { series: (
    { __typename?: 'CircleSeriesNode' }
    & Pick<Types.CircleSeriesNode, 'id' | 'name' | 'slug' | 'accessType'>
  ), facilitators: Array<(
    { __typename?: 'CircleFacilitatorNode' }
    & CircleOnDemandFacilitatorFragment
  )>, relatedTopics?: Types.Maybe<Array<(
    { __typename?: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'id' | 'name' | 'uuid' | 'slug' | 'description' | 'note' | 'format' | 'duration'>
    & { facilitators: (
      { __typename?: 'CircleFacilitatorConnection' }
      & Pick<Types.CircleFacilitatorConnection, 'totalCount'>
      & { edges: Array<Types.Maybe<(
        { __typename?: 'CircleFacilitatorEdge' }
        & Pick<Types.CircleFacilitatorEdge, 'cursor'>
        & { node: (
          { __typename?: 'CircleFacilitatorNode' }
          & CircleOnDemandFacilitatorFragment
        ) }
      )>> }
    ), series: (
      { __typename?: 'CircleSeriesNode' }
      & Pick<Types.CircleSeriesNode, 'id' | 'uuid' | 'name' | 'slug' | 'accessType'>
    ) }
  )>>, video: (
    { __typename?: 'CircleVideoNode' }
    & Pick<Types.CircleVideoNode, 'id' | 'uuid' | 'durationInSeconds' | 'externalVideoUrl' | 'thumbnail'>
  ) }
);

export type GetOnDemandCirclesQueryVariables = Types.Exact<{
  first: Types.Scalars['Int'];
}>;


export type GetOnDemandCirclesQuery = (
  { __typename?: 'Query' }
  & { circleOnDemandConnection: (
    { __typename?: 'CircleOnDemandConnection' }
    & { edges: Array<Types.Maybe<(
      { __typename?: 'CircleOnDemandEdge' }
      & { node: (
        { __typename?: 'CircleOnDemandNode' }
        & CircleOnDemandFragment
      ) }
    )>> }
  ) | { __typename?: 'CirclePermissionDeniedError' } }
);

export const CircleOnDemandFacilitatorFragmentDoc = gql`
    fragment CircleOnDemandFacilitator on CircleFacilitatorNode {
  id
  photo
  name
  credential
  country
  countryCode
}
    `;
export const CircleOnDemandFragmentDoc = gql`
    fragment CircleOnDemand on CircleOnDemandNode {
  id
  uuid
  slug
  series {
    id
    name
    slug
    accessType
  }
  name
  description
  languageCode
  facilitators {
    ...CircleOnDemandFacilitator
  }
  relatedTopics {
    id
    name
    uuid
    slug
    description
    note
    format
    duration
    facilitators {
      totalCount
      edges {
        cursor
        node {
          ...CircleOnDemandFacilitator
        }
      }
    }
    series {
      id
      uuid
      name
      slug
      accessType
    }
  }
  video {
    id
    uuid
    durationInSeconds
    externalVideoUrl
    thumbnail
  }
}
    ${CircleOnDemandFacilitatorFragmentDoc}`;
export const GetOnDemandCirclesDocument = gql`
    query getOnDemandCircles($first: Int!) {
  circleOnDemandConnection(first: $first) {
    ... on CircleOnDemandConnection {
      edges {
        node {
          ...CircleOnDemand
        }
      }
    }
  }
}
    ${CircleOnDemandFragmentDoc}
${CircleOnDemandFacilitatorFragmentDoc}`;
export type GetOnDemandCirclesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>, 'query'> & ({ variables: GetOnDemandCirclesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetOnDemandCirclesComponent = (props: GetOnDemandCirclesComponentProps) => (
      <ApolloReactComponents.Query<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables> query={GetOnDemandCirclesDocument} {...props} />
    );
    
export type GetOnDemandCirclesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>
    } & TChildProps;
export function withGetOnDemandCircles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetOnDemandCirclesQuery,
  GetOnDemandCirclesQueryVariables,
  GetOnDemandCirclesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables, GetOnDemandCirclesProps<TChildProps, TDataName>>(GetOnDemandCirclesDocument, {
      alias: 'getOnDemandCircles',
      ...operationOptions
    });
};

/**
 * __useGetOnDemandCirclesQuery__
 *
 * To run a query within a React component, call `useGetOnDemandCirclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnDemandCirclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnDemandCirclesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetOnDemandCirclesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>(GetOnDemandCirclesDocument, options);
      }
export function useGetOnDemandCirclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>(GetOnDemandCirclesDocument, options);
        }
export type GetOnDemandCirclesQueryHookResult = ReturnType<typeof useGetOnDemandCirclesQuery>;
export type GetOnDemandCirclesLazyQueryHookResult = ReturnType<typeof useGetOnDemandCirclesLazyQuery>;
export type GetOnDemandCirclesQueryResult = ApolloReactCommon.QueryResult<GetOnDemandCirclesQuery, GetOnDemandCirclesQueryVariables>;